import http from "../../http-common";
/* eslint-disable */
class CabangPerdatinService {
  cabangPerdatinList(page, itemPerPage, keyword) {
    return http.get(
      "/cabang-perdatin/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    if (data.no_rekening != null)
      bodyFormData.append("no_rekening", data.no_rekening);
    if (data.nama_rekening != null)
      bodyFormData.append("nama_rekening", data.nama_rekening);
    if (data.virtual_account != null)
      bodyFormData.append("virtual_account", data.virtual_account);
    bodyFormData.append("telp", data.telp);
    bodyFormData.append("fax", data.fax);
    bodyFormData.append("email", data.email);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("website", data.website);
    bodyFormData.append("urutan", data.urutan);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/cabang-perdatin", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    if (data.no_rekening != null)
      bodyFormData.append("no_rekening", data.no_rekening);
    if (data.nama_rekening != null)
      bodyFormData.append("nama_rekening", data.nama_rekening);
    if (data.virtual_account != null)
      bodyFormData.append("virtual_account", data.virtual_account);
    bodyFormData.append("telp", data.telp);
    bodyFormData.append("fax", data.fax);
    bodyFormData.append("email", data.email);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("website", data.website);
    bodyFormData.append("urutan", data.urutan);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/cabang-perdatin/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/cabang-perdatin/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new CabangPerdatinService();
